import { AfterViewInit, Component, HostListener, OnInit, QueryList, ViewChild, ViewChildren,OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActivityTabs, buttonTypes, ComponentTypes } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { CustomFieldsDTO, FullContactDTO, PaymentGateways, PaymentStates, RegisterReservationAttemptResponseDTO } from 'src/app/shared/Models/PartyModels';
import { BookingBehavior } from 'src/app/shared/Models/SessionBookingDTO';
import { ConfirmationVia, operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { environment } from 'src/environments/environment';
import { ActivitiesService } from '../../activities.service';
import { CurrencyDecimalFormatter } from 'src/app/shared/pipes/currency-decimal.pipe';


@Component({
    selector: 'app-activity-guest-edit',
    templateUrl: './activity-guest-edit.component.html',
    styleUrls: ['./activity-guest-edit.component.scss'],
    standalone: false
})
export class ActivityGuestEditComponent extends Utilities implements OnInit, AfterViewInit, OnDestroy{
  guestEditConfig: FieldConfig[];
  MembershipIDConfg: FieldConfig[];
  FirstNameConfig: FieldConfig[];
  LastNameConfig: FieldConfig[];
  HeightConfig: FieldConfig[];
  WeightConfig: FieldConfig[];
  PhoneConfig: FieldConfig[];
  EmailConfig: FieldConfig[];
  cancelBtn: ButtonValue;
  modifyBtn: ButtonValue;
  SpecialNotesConfig: FieldConfig[];
  guestInfoConfig: FieldConfig[] = [];
  customFields = [];
  @ViewChild('guestEditConfig', { static: true }) guestConfigForm: DynamicFormComponent;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  // paymentData: import("c:/Seat Activities/Web-Widget/Activities-Web-Widget/src/app/shared/Models/PartyModels").RegisterReservationAttemptResponseDTO;
  paymentData: RegisterReservationAttemptResponseDTO;
  urlSafe: any;
  showIframe: boolean;
  isUserAllowedToclickConfirm: boolean;
  waiverFormTrancationId: any;
  guestDetailsForm: UntypedFormGroup;
  financialPopUpRef: any;
  popUpMessage: string;
  PartyData: any;
  SelectedContactInfo: any;
  subscriptions: Subscription = new Subscription();
  constructor(private ts: TranslateService, public dialog: MatDialog, private activityService: ActivitiesService, public sanitizer: DomSanitizer, public fb: UntypedFormBuilder, private currencyDecimalFormatter: CurrencyDecimalFormatter) {
    super(dialog);
    this.activityService.editPartyData$.subscribe(data => {
      if (data) {
        this.PartyData = data;
        this.SelectedContactInfo = data.Contact;
      }
    })
    this.activityService.PaymentData$.subscribe(data => {
      if (data) {
        this.paymentData = this.activityService.reservationAttemptInfo = data;
        if (data.ShouldCreditCardBeEntered && this.activityService.ispaymentInvolvedInfo.CreditCardRequired) {
          if (this.activityService.reservationAttemptInfo.CreditCardIFrameURL) {
            this.LoadIframe(this.activityService.reservationAttemptInfo.CreditCardIFrameURL);
          }
          else {
            const message = this.ts.instant('SorryForPaymentOffline');
          }
        }
        if (this.activityService.operation == operationType.edit && this.activityService.editPartyData$.value) {
          this.getFinancialEffectCalculation();
        }
      }
    })
    this.setFormConfig();
  }

  ngOnInit(): void {

    this.activityService.operation == operationType.edit ? this.RegisterReservationAttempt(true) : this.GetPreliminaryReservationInformation();
  }

  ngAfterViewInit() {
    this.guestDetailsForm = this.fb.group({
      primaryGuest: this.components.first.form,
      //   secondaryContactList: ''
    })
    if (!this.activityService.ispaymentInvolvedInfo.CreditCardRequired) {
      this.isUserAllowedToclickConfirm = true
    }

    this.subscriptions.add(this.guestDetailsForm.valueChanges.subscribe(data => {
      this.modifyBtn.disbaledproperity = this.guestDetailsForm.invalid || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
    }));
  }

  setFormConfig() {
    this.cancelBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('clearAll'),
      customclass: 'reservation-confirmation__cancel-reservation',
    };

    this.modifyBtn = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('submit'),
      customclass: 'reservation-confirmation__modify-details',
      disbaledproperity: true
    };
    this.guestInfoConfig = [
      {
        type: 'input',
        name: 'FirstName',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('firstName'),
        class: "guest-edit-details",
        validation: [Validators.required],
        value: this.SelectedContactInfo ? this.SelectedContactInfo.FirstName : ''
      }, {
        type: 'input',
        name: 'LastName',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('lastName'),
        class: "guest-edit-details",
        validation: [Validators.required],
        value: this.SelectedContactInfo ? this.SelectedContactInfo.LastName : ''

      },
      {
        type: 'input',
        name: 'Phone',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('phone'),
        class: "guest-edit-details",
        validation: [Validators.required],
        value: this.SelectedContactInfo ? this.SelectedContactInfo.PhoneNumber : ''

      }, {
        type: 'input',
        name: 'Email',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('email'),
        class: "guest-edit-details",
        validation: [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$')],
        value: this.SelectedContactInfo ? this.SelectedContactInfo.EmailAddress : ''
      }];

    const checkBoxConfig = [{
      type: 'checkbox',
      placeholder: this.ts.instant('SmsMessageReminderText'),
      value: this.PartyData ? this.PartyData.RemindAboutVisit : false,
      name: 'RemindBySMS',
      class: 'guest-edit-details',
      isFormArray: false,
      appearance: true,
      label: this.ts.instant('SmsMessageReminderText'),

    }, {
      type: 'checkbox',
      placeholder: this.ts.instant('emailReminderText'),
      value: this.PartyData ? this.PartyData.RemindAboutVisitEmail : false,
      name: 'RemindByEmail',
      class: 'guest-edit-details',
      isFormArray: false,
      appearance: true,
      label: this.ts.instant('emailReminderText'),

    }, {
      type: 'checkbox',
      placeholder: this.ts.instant('smsConfirmationText'),
      value: false,
      name: 'ConfirmBySMS',
      class: 'guest-edit-details',
      isFormArray: false,
      appearance: true,
      label: this.ts.instant('smsConfirmationText'),
    }, {
      type: 'checkbox',
      placeholder: this.ts.instant('emailConfirmationText'),
      value: false,
      name: 'ConfirmByEmail',
      class: 'guest-edit-details',
      isFormArray: false,
      appearance: true,
      label: this.ts.instant('emailConfirmationText')
    }];

    this.activityService.customGuestFields.CustomGuestField.forEach(field => {
      let fieldValue = ''

      if (field.IsCustomGuestFieldVisible) {
        field['formName'] = 'customGuestField_' + field.Id.toString();
        this.customFields.push(field);
        if (field.FieldType == 'Text Field') {
          this.guestInfoConfig.push({
            type: 'input',
            placeholder: field.FieldName,
            value: fieldValue ? fieldValue : '',
            name: 'customGuestField_' + field.Id.toString(),
            class: 'guest-edit-details column',
            isFormArray: false,
            appearance: true,
            label: field.FieldName,
          });
        }
        if (field.FieldType == 'Drop Down') {
          let Options = [];
          Options = field.FieldOptions.split(',').map(x => { return { id: x, value: x } });
          Options.splice(0, 0, { id: '', value: field.FieldName })
          this.guestInfoConfig.push({
            type: 'select',
            placeholder: field.FieldName,
            options: Options,
            value: fieldValue ? fieldValue : Options[0].id,
            name: 'customGuestField_' + field.Id.toString(),
            class: 'guest-edit-details column',
            isFormArray: false,
            appearance: true,
            label: field.FieldName,
          });
        }
      }
    });
    this.guestInfoConfig.push(...checkBoxConfig);
  }

  clearDetails(event) {
    const GuestForm = this.guestDetailsForm.controls.primaryGuest as UntypedFormGroup;
    GuestForm.reset();
  }

  submitDetails(event) {
    this.guestDetailsForm = this.fb.group({
      primaryGuest: this.components.first.form,
      //   secondaryContactList: ''
    })
    this.setGuestDetails();

  }

  setGuestDetails() {
    var ContactObj = {} as FullContactDTO;
    var primaryGuest = this.guestDetailsForm.controls.primaryGuest as UntypedFormGroup;
    var Notes = this.components.last;
    ContactObj.FirstName = primaryGuest.get("FirstName").value;
    ContactObj.LastName = primaryGuest.get("LastName").value;
    ContactObj.ContactCustomFields = this.getCustomGuestFieldsValue();
    ContactObj.PhoneNumber = primaryGuest.get("Phone").value;
    ContactObj.EmailAddress = primaryGuest.get("Email").value;
    this.activityService.SaveBookingObj.Contact = ContactObj;
    this.activityService.createSessionBooking(this.activityService.SaveBookingObj).subscribe(data => {
      this.getByToken(data.Token)
      this.activityService.createActivityResponse$.next(data);
      this.activityService.TabChange$.next(ActivityTabs.ActivitySelection);
    });
  }

  getCustomGuestFieldsValue() {
    let CustomFieldsList: CustomFieldsDTO[] = [];
    if (this.activityService.customGuestFields && this.activityService.customGuestFields.CustomGuestField.length > 0) {
      this.activityService.customGuestFields.CustomGuestField.forEach(field => {
        if (this.guestDetailsForm.value.primaryGuest['customGuestField_' + field.Id.toString()]) {
          let customField = new CustomFieldsDTO();
          customField.CustomFieldId = Number(field.Id);
          customField.CustomFieldValue = this.components['customGuestField_' + field.Id.toString()];
          CustomFieldsList.push(customField);
        }
      })
    }
    return CustomFieldsList;
  }


  GetPreliminaryReservationInformation() {
    this.activityService.GetPreliminaryReservationInformation(this.activityService.SessionBookingObj.ActivityId).subscribe(data => {
      if (data) {
        //this.RegisterReservationAttempt();
        this.activityService.ispaymentInvolvedInfo = data;
        // if (this.partyDetails.specialMeal.WaiverFormCode || (this.activityService.restaurantWidgetSettings$.value.DefaultWaiverForm && this.activityService.restaurantWidgetSettings$.value.DefaultWaiverForm.Applied)) {
        //   this.isUserAllowedToclickConfirm = false;
        //   this.LoadGuestWaiverForm(this.partyDetails.specialMeal.WaiverFormCode ? this.partyDetails.specialMeal.WaiverFormCode : this.activityService.restaurantWidgetSettings$.value.DefaultWaiverForm.FormCode) // disable confirm button
        // }
        // else {
        if (this.activityService.ispaymentInvolvedInfo.CreditCardRequired) {
          this.RegisterReservationAttempt(true) // diable confirm button
        } else {
          this.isUserAllowedToclickConfirm = true;
        }
      }
    });
  }

  getByToken(token) {
    this.activityService.getByToken(token).subscribe(data => {
      this.activityService.SaveBookingObj = data;
      this.activityService.editPartyData$.next(data);
    });
  }

  RegisterReservationAttempt(isIframeToBeDisplayed: boolean) {
    let registerReservationAttemptRequestDTO = {
      PartySize: this.activityService.SaveBookingObj?.Size,
      Sessions: this.activityService.SaveBookingObj?.Sessions,
      ActivityId: this.activityService.SaveBookingObj?.Id,
      CoverTypes: this.activityService.SaveBookingObj?.CoverTypes,
      BookingTypes: this.activityService.SaveBookingObj?.BookingTypes,
      PartyId: null
    }
    this.activityService.RegisterReservationAttempt(registerReservationAttemptRequestDTO).subscribe(data => {
      if (data) {
        this.paymentData = this.activityService.reservationAttemptInfo = data;
        if (data.ShouldCreditCardBeEntered && isIframeToBeDisplayed) {
          if (this.activityService.reservationAttemptInfo.CreditCardIFrameURL) {
            this.LoadIframe(this.activityService.reservationAttemptInfo.CreditCardIFrameURL);
          }
          else {
            const message = this.ts.instant('SorryForPaymentOffline');
          }
        }
        if (this.activityService.operation == operationType.edit && this.activityService.editPartyData$.value) {
          this.getFinancialEffectCalculation();
        }
      }
    })

  }

  getConfirmationMessageOption() {
    if (this.activityService.restaurantWidgetSettings$.value.ConfirmationVia == ConfirmationVia.Both) {
      if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']
        && this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']) {
        return ConfirmationVia.Both;
      }
      else if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']) {
        return ConfirmationVia.Email;
      }
      else if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']) {
        return ConfirmationVia.Sms;
      }
      else {
        return this.activityService.restaurantWidgetSettings$.value.ConfirmationVia;
      }
    }
    else {
      return this.activityService.restaurantWidgetSettings$.value.ConfirmationVia;
    }
  }

  buildReservationRequest() {
    const bookingData = this.activityService.SaveBookingObj;
    let partyDTO: any = {
      Id: this.activityService.operation == operationType.edit ? this.activityService.editPartyData$.value.Id : null,
      Size: bookingData.Size,
      RemindAboutVisit: this.activityService.restaurantWidgetSettings$.value.IsSmsReminderSupported ? this.activityService.restaurantWidgetSettings$.value.WidgetCustomization.IsReservationReminderMandatory ? true : this.guestDetailsForm.value.primaryGuest['RemindBySMS'] : false,// get Value froom form
      RemindAboutVisitEmail: this.guestDetailsForm.value.primaryGuest['RemindByEmail'],//
      AgreedWithTermsOfUse: true,
      Contact: bookingData.Contact,
      Slot: bookingData.Slot,
      PartyId: this.activityService.operation == operationType.edit ? this.activityService.editPartyData$.value.Id : null,
      SpecialMealId: this.activityService.operation == operationType.create ? bookingData.ActivityId : bookingData.specialMeal.Id,
      ConfirmationMessageOption: this.getConfirmationMessageOption(),
      TableIds: bookingData.TableIds,
      InstructorIds : bookingData.StaffId,
      CoverTypes: bookingData.GuestTypes,//Bind Cover types
      BookingTypes: bookingData.BookingTypes,//Bind Booking types
      IsCommunalTable: false,
      FromWebsite: true,
      Language: this.activityService.language, // get language id 
      ReservationAttemptId: this.activityService.reservationAttemptInfo && this.activityService.reservationAttemptInfo.ReservationAttemptId ? this.activityService.reservationAttemptInfo.ReservationAttemptId : null,
      waiverFormTransactionId: this.waiverFormTrancationId ? this.waiverFormTrancationId : (this.activityService.operation == operationType.edit && this.activityService.editPartyData$.value.WaiverFormTransactionId) ? this.activityService.editPartyData$.value.WaiverFormTransactionId : null,
      BookingBehavior: BookingBehavior.ClassOrSession
      //SecondaryContactsList: this.activityService.operation ==operationType.edit ? this.buildSecondaryContactList() : null
    };

    if (this.activityService.operation != operationType.edit && this.guestDetailsForm.value.primaryGuest.dataRetention) {
      partyDTO.Contact.ConsentDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');
      // partyDTO.Contact.ConsentPolicyId = this.activityService.dataRetentionPolicy$.value.Id;
    }

    return partyDTO;
  }
  showFinancialEffectPopUp(Message: string) {
    const popUpMessage = [{
      confirmationMessage: Message,
      dialogTitle: this.ts.instant('paymentInfo'),
      showAlert: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.financialPopUpRef = this.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '450px', '300px', true, 'No', 'Ok',
      'Cancel', true)
  }


  getFinancialEffectCalculation() {
    let partyDTO = this.buildReservationRequest();
    this.activityService.GetFinancialEffectCalculation(partyDTO).subscribe(data => {
      if (data) {

        switch (data.PartyPaymentType) {
          case 0: // NotSupported           
            this.activityService.message = this.ts.instant("ReservationBetweenLocationPrePaidNotSupported");
            this.isUserAllowedToclickConfirm = false;
            return;
            break;
          case 1: // NoPaymentsInvolved
            // No messaging in this case
            break;
          case 2: // NoEffect
            this.showFinancialEffectPopUp(this.ts.instant('NoChargeOrRefundForThisReservation'));
            break;
          case 3: // NewReservationAttempt
            //paymentIframeRequired = true; 
            if (this.isSelectedMealDefferedPayment()) {
              this.popUpMessage = this.ts.instant('priorChargeThroughCard');
            } else {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 4: // NoFullRefund
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('NoChargeOrRefundForThisReservation');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 5: // FullRefund 
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 6: // NoFullRefundAndNewReservationAttempt            
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('noRefundMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 7: // FullRefundAndNewReservationAttempt          
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 8: // PartialCharge
            if (this.activityService.reservationAttemptInfo.ShouldCreditCardBeEntered) {
              this.popUpMessage = this.ts.instant('CardNeededToUpdateThisReservation') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('enterCreditCard');
            }
            else {
              this.popUpMessage = this.ts.instant('CardUsedForTheOriginalBookingWillCharged') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits);

            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 9: // PartialRefund

            this.popUpMessage = this.ts.instant('refundMessage') + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + Math.abs(data.PaymentAmount).toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ".<br />" + this.ts.instant('severalDaysMessage');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 10: // NoShowFeeUpdated
            this.popUpMessage = this.ts.instant('IfDonotShowYouWillBeCharged') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 11: // Authorize

            if (data.TotalAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
          case 12: // Authorize updated
            if (data.TotalAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' + this.activityService.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.activityService.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
        }
        // this.bindPaymentAmountAndMessage(data.RatePlanAmount, data.SpecialMealAmount, data.TotalAmount) // need to check how to find deferred payment mode 
        if (this.activityService.reservationAttemptInfo.ShouldCreditCardBeEntered) {
          this.isUserAllowedToclickConfirm = false;
          this.modifyBtn.disbaledproperity = true;
          this.LoadIframe(this.activityService.reservationAttemptInfo.CreditCardIFrameURL);
        }
        else {
          this.isUserAllowedToclickConfirm = true;
          this.modifyBtn.disbaledproperity = this.activityService.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationVia == ConfirmationVia.Both;
        }
      }
    });
  }

  LoadIframe(iframeURl: string) {
    if (iframeURl) {
      const IframeModifiedURL = iframeURl + "&origin=" + window.location.origin;
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(IframeModifiedURL);
      this.showIframe = true;
    }
    else {
      this.activityService.message = this.ts.instant('somethingWentWrong');
    }
  }



  @HostListener('window:message', ['$event'])
  onMessage({ origin, data }) {
    if (origin != environment.authorizeIframeResponseOrigin && origin != environment.rGuestPayIframeResponsOrigin) { // set your origin
      return false;
    }
    var rGuestPayRespose = data;
    var payResponse = data;
    if (typeof data != "object") {
      rGuestPayRespose = JSON.parse(data);
    }
    if ((data.type == "txn-completed" && data.transactionInfo && data.transactionInfo.transactionInfo && data.transactionInfo.transactionInfo.saleResponse) || (rGuestPayRespose && (rGuestPayRespose.code || rGuestPayRespose.gatewayResponseData))) {
      if (this.paymentData.PaymentGateway == PaymentGateways.AuthorizePay) { //Authorize Pay 
        var transInfo = payResponse.transactionInfo.transactionInfo;
        var cardInfo = transInfo.saleResponse.cardInfo;
        var gatewayResponseData = transInfo.saleResponse.gatewayResponseData;
        var transactionReferenceData = transInfo.saleResponse.transactionReferenceData;
        var transactionResponseData = transInfo.saleResponse.transactionResponseData;

        if (transInfo.errorMessage || transInfo.successCode != 1) {
          if (transInfo.errorMessage) {
            this.activityService.message = transInfo.errorMessage;
          }
          else if (gatewayResponseData.message) {
            this.activityService.message = gatewayResponseData.message;
          }
          else {
            this.activityService.message = this.ts.instant("CardInformationProcessNotCompleted");
          }
        } else if (payResponse && transInfo && transInfo.successCode == 1) {
          var callbackDto = this.getPaymentCallbackRequestDTO(cardInfo, transactionReferenceData, transInfo, transactionResponseData, this.paymentData.PaymentGateway);
          this.UpdateReservationAttempt(callbackDto);
        } else {
          this.activityService.message = this.ts.instant("CardInformationProcessNotCompleted");
        }
      }
      else {
        if (rGuestPayRespose.code && rGuestPayRespose.code != "100") {
          rGuestPayRespose = JSON.parse(data);
          if (rGuestPayRespose.validationErrors && rGuestPayRespose.validationErrors.length > 0) {
            var errorString = "";
            rGuestPayRespose.validationErrors.forEach(function (error, i, arr) {
              errorString = error.fieldName + " " + error.value + "\n";
            })
            this.activityService.message = errorString;
          }
          else if (rGuestPayRespose && rGuestPayRespose.gatewayResponseData && rGuestPayRespose.gatewayResponseData.message) {
            alert(rGuestPayRespose.gatewayResponseData.message);
          }
          else {
            this.activityService.message = this.ts.instant("CardInformationProcessNotCompleted");
          }
        }
        else if (rGuestPayRespose && rGuestPayRespose.gatewayResponseData && rGuestPayRespose.gatewayResponseData.code == "100") {
          let callbackDto = {
            ReservationAttemptId: this.paymentData.ReservationAttemptId,
            CardNumber: rGuestPayRespose.cardInfo.accountNumberMasked,
            ExpirationDate: new Date(data.cardInfo.expirationYearMonth.substring(0, 4) + '-' + data.cardInfo.expirationYearMonth.substring(4) + '-01'),
            CVC: "",
            FirstNameHolder: "",
            LastNameHolder: "",
            AddressLine1: "",
            AddressLine2: "",
            City: "",
            State: "",
            PostalCode: "",
            TokenType: "",
            Token: data.token
          };
          this.UpdateReservationAttempt(callbackDto);
        }
        else {
          this.activityService.message = this.ts.instant("CardInformationProcessNotCompleted");
        }
      }
    }
    else if (data.type == "txn-completed" && data.transactionInfo) {
      this.showIframe = false;
      this.waiverFormTrancationId = data.transactionInfo.authorizeTransactionID;
      let invoiceId = data.transactionInfo.invoiceID;
      if (this.activityService.ispaymentInvolvedInfo && this.activityService.ispaymentInvolvedInfo.CreditCardRequired) {
        this.isUserAllowedToclickConfirm = false;
        if (this.activityService.reservationAttemptInfo) {
          if (this.activityService.reservationAttemptInfo.CreditCardIFrameURL) {
            this.LoadIframe(this.activityService.reservationAttemptInfo.CreditCardIFrameURL)
          }
          else {
            this.activityService.message = this.ts.instant('SorryForPaymentOffline');
          }
        }
        else {
          this.RegisterReservationAttempt(true);
        }
      }
      else {
        this.isUserAllowedToclickConfirm = true;
        if (!this.checkCustomTermsAndMessageOptionValidation()) {
          this.activityService.message = this.ts.instant('completeAllFields');
          this.showIframe = false;
        }
        else {
          this.reservationConfirm();
        }
      }
    } else {
      //Show Error Message  
    }
  }

  reservationConfirm() {
    this.isUserAllowedToclickConfirm = true;
    this.modifyBtn.disbaledproperity = this.guestDetailsForm.invalid || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();

    if(this.activityService.operation == operationType.edit && this.activityService.editPartyData$.value)
          {
            this.activityService.updateSessionBooking(this.activityService.SaveBookingObj).subscribe(data => {
              this.getByToken(data.Token)
              this.activityService.createActivityResponse$.next(data);
              this.activityService.TabChange$.next(ActivityTabs.ActivitySelection);
            });
          }
          else
          {
          this.activityService.createSessionBooking(this.activityService.SaveBookingObj).subscribe(data => {
            this.getByToken(data.Token)
            this.activityService.createActivityResponse$.next(data);
            this.activityService.TabChange$.next(ActivityTabs.ActivitySelection);
          });
        }
  }

  checkCustomTermsAndMessageOptionValidation() {
    let isApproved = true;
    if (this.activityService.additionalGuestPage) {
      return true;
    }

    if (this.activityService.restaurantWidgetSettings$.value.ConfirmationVia == ConfirmationVia.Both
      && !this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']
      && !this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']
    ) {
      isApproved = false;
    }
    return isApproved;
  }

  isPartySizeMatchSecondaryContactList(): boolean {
    if (this.activityService.operation == operationType.edit && this.activityService.editPartyData$.value.SecondaryContacts && this.activityService.editPartyData$.value.SecondaryContacts.length > 0 && this.activityService.partySize < this.components.toArray().length) {
      return false;
    }
    else {
      return true;
    }
  }


  getPaymentCallbackRequestDTO(cardInfo: any, transactionReferenceData: any, transInfo: any, transactionResponseData: any, paymentGateway: PaymentGateways) {
    let paymentCallbackRequestDTO = {
      RestaurantId: this.activityService.restaurantWidgetSettings$.value.RestaurantId,
      ReservationAttemptId: this.paymentData.ReservationAttemptId,
      CardNumber: cardInfo.accountNumberMasked,
      ExpirationDate: cardInfo.expirationYearMonth.substring(0, 4) + '-' + cardInfo.expirationYearMonth.substring(4) + '-01',
      CVC: "",
      FirstNameHolder: "",
      LastNameHolder: "",
      AddressLine1: "",
      AddressLine2: "",
      City: "",
      State: "",
      PostalCode: "",
      TokenType: "",
      Token: transactionReferenceData ? transactionReferenceData.token : null,
      PaymentAmount: transactionResponseData.totalAmount,
      AuthorizeTransactionID: transInfo ? transInfo.authorizeTransactionID : null,
      PaymentType: transInfo ? transInfo.paymentType : null,
      InvoiceID: transInfo ? transInfo.invoiceID : null,
      PaymentGateway: paymentGateway,
      TransactionFollowOnData: transactionReferenceData ? transactionReferenceData.transactionFollowOnData : null,
      TransactionDate: transInfo.transactionsDate,
      IssuerType: transactionReferenceData &&  transactionReferenceData.tender ?  transactionReferenceData.tender : null,
    }
    return paymentCallbackRequestDTO;
  }

  UpdateReservationAttempt(Dto) {
    this.activityService.UpdateReservationAttempt(Dto).subscribe(data => {
      if (data && (data.ErrorMessage || data.ExceptionMessage || (data.ValidationMessages && data.ValidationMessages.length > 0) || data.length == 0)) {
        if (data.ErrorMessage && data.ErrorMessage.length > 0) {
          var sorrysomethingwentwromg = this.ts.instant('SorryWeGotSomeErrorWhileProcessing');
          var CCUprocessableTryAgainErrorMessage = this.ts.instant('CCUprocessableTryAgainErrorMessage');
          var ImportantErrorMessage = this.ts.instant('ImportantErrorMessage');
          var CreditCardAuthorizationError = this.ts.instant('CreditCardAuthorizationError');
          var TryAgainMessage = this.ts.instant('TryAgainMessage');
          var CardNumbershouldContainOnlyDigits = this.ts.instant('CardNumbershouldContainOnlyDigits');
          var CardNumberShouldConsists13To16Digits = this.ts.instant('CardNumberShouldConsists13To16Digits');
          var CardNumberShouldNotBlank = this.ts.instant('CardNumberShouldNotBlank');
          var SorryWeGotSomeErrorCardExpired = this.ts.instant('SorryWeGotSomeErrorWhileProcessingCardExpired');
          if (data.ErrorMessage == "Please try it one more time, if the problem repeats, contact to rGuestSeat@Agilysys.com")
            var url = sorrysomethingwentwromg + TryAgainMessage;
          else if (data.ErrorMessage == "We're sorry, but we couldn�t process your credit card based on the information you provided. Please try again.")
            var url = sorrysomethingwentwromg + CCUprocessableTryAgainErrorMessage;
          else if (data.ErrorMessage == "[IMPORTANT] Some error happens at the moment of database saving. There is a probability that the payment transaction has performed successfully but this fact hasn't been saved properly. Don't try to do it one more time. Please, contact rGuestSeat@Agilysys.com regarding this error")
            var url = sorrysomethingwentwromg + ImportantErrorMessage;
          else if (data.ErrorMessage == "The provided credit card hasn't been authorized succesfully")
            var url = sorrysomethingwentwromg + CreditCardAuthorizationError;
          else if (data.ErrorMessage.indexOf("The card is expired") > 0)
            var url = SorryWeGotSomeErrorCardExpired;
          else if (data.ErrorMessage == "The card number should consist of only digits")
            var url = sorrysomethingwentwromg + CardNumbershouldContainOnlyDigits;
          else if (data.ErrorMessage == "The card number should consist of from 13 to 16 digits")
            var url = sorrysomethingwentwromg + CardNumberShouldConsists13To16Digits;
          else if (data.ErrorMessage == "The card number shouldn't be blank")
            var url = sorrysomethingwentwromg + CardNumberShouldNotBlank;
          else
            var url = sorrysomethingwentwromg + data.ErrorMessage;
          this.activityService.message = url;
        }
        else {
          var url = sorrysomethingwentwromg + TryAgainMessage;
          this.activityService.message = url;
        }
        this.activityService.message = url;
      }
      else {
        this.activityService.GetRegisterReservationAttempt(this.paymentData.ReservationAttemptId).subscribe(data => {
          if (data && (data.State == PaymentStates.Authorized || data.State == PaymentStates.ChargeCaptured)) {
            this.isUserAllowedToclickConfirm = true;
            if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
              this.activityService.message = this.ts.instant('completeAllFields');
              this.showIframe = false;
            }
            else {
              this.reservationConfirm();
            }
          }
          else {
            this.activityService.message = this.ts.instant("CreditCardNotBeProcessed");
          }
        });
      }
    });
  }


  isSelectedMealDefferedPayment(): boolean {
    let isDeffered = false;
    // if (this.activityService.SelectedActivity.specialMeal.value) {
    //   isDeffered = (this.rs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value.DoesRequirePrepayment && !this.rs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value.ChargeOnBooking) ? true : false;
    // }
    return isDeffered;
  }
  ngOnDestroy(): void {
    if (this.subscriptions) { this.subscriptions.unsubscribe(); }
  }
}
